// Plugin: jQuery.mousetip
// Source: github.com/nathco/jQuery.mousetip
// Author: Nathan Rutzky
// Update: 1.00
    
$.fn.mousetip = function(tip, x, y) {    
    var $this = $(this);    
    $this.hover(function() {        
        $(tip, this).show();    
    }, function() {    
        $(tip, this).hide().removeAttr('style');    
    }).mousemove(function(e) {        
        var mouseX = e.pageX + (x || -50);
        var mouseY = e.pageY + (y || -80);    
        $(tip, this).show().css({            
            top:mouseY, left:mouseX            
        });
    });
};

$(function() {
	$('.mouse-follow-target').mousetip('.mouse-follow-content');
});
